var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('PxHeader'),_c('router-view',{staticClass:"container px-5 sm:px-20 py-20 flex justify-center"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }